import { useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  const isActive = useCallback((path: string) => location.pathname === path, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 group" aria-label="韩漫屋首页">
            <span className="text-2xl font-heading font-bold text-primary-500">韩漫屋</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${isActive('/') ? 'text-primary-500' : 'text-foreground-600 hover:text-primary-500'}`}
            >
              首页
            </Link>
            <div className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <Link
                to="/category/all"
                className={`text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-1 ${location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-600 hover:text-primary-500'}`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </Link>
              {categoryOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                  <div className="bg-background-50 border border-background-200/70 rounded-lg py-2 px-1 shadow-sm min-w-[160px]">
                    {categories.filter(c => c.slug !== 'all').map(cat => (
                      <Link
                        key={cat.id}
                        to={`/category/${cat.slug}`}
                        className="block px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md whitespace-nowrap transition-colors"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${isActive('/about') ? 'text-primary-500' : 'text-foreground-600 hover:text-primary-500'}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4">
            <div className="flex flex-col gap-2 max-w-7xl mx-auto">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive('/') ? 'bg-primary-50 text-primary-500' : 'text-foreground-700 hover:bg-background-100'}`}
              >
                首页
              </Link>
              <div className="px-4 py-2 text-xs font-medium text-foreground-400 uppercase tracking-wider">漫画分类</div>
              {categories.filter(c => c.slug !== 'all').map(cat => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${location.pathname === `/category/${cat.slug}` ? 'bg-primary-50 text-primary-500' : 'text-foreground-700 hover:bg-background-100'}`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive('/about') ? 'bg-primary-50 text-primary-500' : 'text-foreground-700 hover:bg-background-100'}`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}